/* esm.sh - applesauce-core@5.2.0/helpers/event */
export * from "/*applesauce-core@5.2.0/esnext/helpers/event.mjs";
